/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Import_Feed_LoadingInputs */

const cs_import_feed_loading = /** @type {(inputs: Import_Feed_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Připravuji stažení feedu…`)
};

const en_import_feed_loading = /** @type {(inputs: Import_Feed_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preparing feed download…`)
};

/**
* | output |
* | --- |
* | "Preparing feed download…" |
*
* @param {Import_Feed_LoadingInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const import_feed_loading = /** @type {((inputs?: Import_Feed_LoadingInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Import_Feed_LoadingInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_import_feed_loading(inputs)
	return cs_import_feed_loading(inputs)
});